// The words that travel with a shared link. Whoever receives it must see at once that it comes
// from Лупа and what it is — not a bare URL. The card under the link is a separate thing
// (sharePreviews.ts); the app keeps the same texts in mobile/src/utils/shareMessages.ts.

export type ShareMessage = {
  /** Email subject and the share sheet's title. */
  subject: string
  /** The sentence the link follows, without the link. */
  lead: string
}

export const TRACKING_SHARE: ShareMessage = {
  subject: 'Отслеживание перевозки в Лупе',
  lead: 'С вами поделились отслеживанием перевозки в Лупе. Где машина сейчас — по ссылке',
}

export const DRIVER_INVITATION_SHARE: ShareMessage = {
  subject: 'Приглашение на заявку в Лупе',
  lead: 'Вас приглашают на заявку в Лупе. Для надёжного отслеживания во время рейса рекомендуем приложение на Android. Посмотреть и принять заявку',
}

export const REFERRAL_SHARE: ShareMessage = {
  subject: 'Приглашение в Лупу',
  lead: 'Присоединяйтесь к Лупе — сервису отслеживания перевозок. Регистрация по моей ссылке',
}

// A driver recommends Лупа to a logist (lib/logistInvite.ts) — no bonus, no code, just the link.
export const LOGIST_INVITATION_SHARE: ShareMessage = {
  subject: 'Лупа — отслеживание перевозок',
  lead: 'Рекомендую Лупу: машина видна на карте, и не нужно звонить водителю с вопросом «Где машина?». Посмотрите',
}

export function referralCodeText(code: string) {
  return `Присоединяйтесь к Лупе — сервису отслеживания перевозок. Мой код приглашения: ${code}`
}

export function shareMessageText(message: ShareMessage, url: string) {
  return `${message.lead}: ${url}`
}

export type ShareTargets = {
  email: string
  whatsapp: string
  telegram: string
  sms: string
}

// Each service gets the same message; only the transport differs: Telegram takes the URL in its
// own field and puts the text under it, the other schemes send one text body.
export function buildShareTargets(message: ShareMessage, url: string): ShareTargets {
  const text = shareMessageText(message, url)

  return {
    email: `mailto:?subject=${encodeURIComponent(message.subject)}&body=${encodeURIComponent(text)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(text)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(message.lead)}`,
    sms: `sms:?body=${encodeURIComponent(text)}`,
  }
}
